import { rem } from '../utils/polished';

const SPACING_BASE = 8;
export const spacing = (amount: number) => rem(`${amount * SPACING_BASE}px`);
